import React, { useState, useEffect } from "react";
import useAxios from "../../utils/useAxios";

const UserFavoriteRecipes = () => {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const axiosAPI = useAxios();

  const fetchFavorites = async () => {
    try {
      const response = await axiosAPI.get(`/api/recipe-management/favorite-recipes`);
      if (response.data.success) {
        setFavorites(response.data.favorites);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching favorites:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFavorites();
  }, []);

  return (
    <div className="container">
      <div className="page-inner">
        <div className="page-header">
          <h3 className="fw-bold mb-3">Favorite Recipes</h3>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">User Favorites</h4>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="display table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>User Name</th>
                        <th>Email</th>
                        <th>Recipe Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr><td colSpan="3">Loading...</td></tr>
                      ) : favorites.length > 0 ? (
                        favorites.map((fav, index) => (
                          <tr key={index}>
                            <td>{fav.user_name}</td>
                            <td>{fav.email}</td>
                            <td>{fav.recipe_name}</td>
                          </tr>
                        ))
                      ) : (
                        <tr><td colSpan="3">No favorites found.</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserFavoriteRecipes;
